import { Injectable, signal } from '@angular/core';

/**
 * Holds the name of the currently active workspace for display in the browser
 * title bar. Set by `WorkSpaceMicroComponent` when the selection changes and
 * cleared when it is destroyed (i.e. when navigating away from a workspace
 * page). Read by `AppComponent` when it builds the document title.
 */
@Injectable({
  providedIn: 'root'
})
export class WorkspaceTitleService {
  private readonly workspaceNameState = signal<string | null>(null);

  readonly workspaceName = this.workspaceNameState.asReadonly();

  setWorkspaceName(name: string | null): void {
    this.workspaceNameState.set(name);
  }
}
